(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["afterform-catalog"] && !Shopify.designMode) return;
  try {
    
function initAfterformCatalog(){
document.querySelectorAll('.af-catalog').forEach(root=>{
if(root.dataset.ready)return;
root.dataset.ready='true';
const grid=root.querySelector('.af-product-grid');
const cards=Array.from(grid.children);
const search=root.querySelector('[data-af-search]');
const sort=root.querySelector('[data-af-sort]');
let category='all';
function render(){
const term=search.value.trim().toLowerCase();
let list=cards.slice();
if(sort.value==='low')list.sort((a,b)=>+a.dataset.price-+b.dataset.price);
else if(sort.value==='high')list.sort((a,b)=>+b.dataset.price-+a.dataset.price);
else if(sort.value==='name')list.sort((a,b)=>a.dataset.name.localeCompare(b.dataset.name));
else list.sort((a,b)=>+b.dataset.art-+a.dataset.art);
let total=0;
list.forEach(card=>{card.hidden=(category!=='all'&&card.dataset.category!==category)||!card.dataset.name.includes(term);if(!card.hidden)total++;grid.append(card)});
root.querySelector('[data-af-count]').textContent=total;
root.querySelector('[data-af-empty]').hidden=total!==0;
root.querySelectorAll('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.filter===category)));
}
function fromHash(){
const hash=location.hash;
if(hash==='#af-catalog'){category='all';search.value='';render();}
if(hash.startsWith('#af-category-')){const next=hash.slice(13);category=cards.some(c=>c.dataset.category===next)?next:'all';render();root.scrollIntoView({behavior:'instant',block:'start'})}
}
root.querySelectorAll('[data-filter]').forEach(b=>b.addEventListener('click',()=>{category=b.dataset.filter;render()}));
search.addEventListener('input',render);
sort.addEventListener('change',render);
window.addEventListener('hashchange',fromHash);
render();fromHash();
});
}
initAfterformCatalog();
document.addEventListener('shopify:section:load',initAfterformCatalog);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
